const departmentSettings = (departmentSettingsJson) => {
  const properties = { ...departmentSettingsJson.attributes };
  return properties;
};

export default departmentSettings;
